<div #forecastLineChart class="forecast_line_chart"></div>
